var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-badge',{attrs:{"label":_vm.label,"className":_vm.className}})
}
var staticRenderFns = []

export { render, staticRenderFns }